// 加载遮罩组件
import React from 'react';
import { Loader2 } from 'lucide-react';

interface LoadingOverlayProps {
  isVisible: boolean;
  message?: string;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ 
  isVisible, 
  message = 'Processing...' 
}) => {
  if (!isVisible) return null;

  return (
    <div className="ai-loading-overlay">
      <div className="ai-loading-content">
        <Loader2 className="ai-loading-spinner" />
        <p className="ai-loading-message">{message}</p>
      </div>
    </div>
  );
};

export default LoadingOverlay;